import { Outlet } from 'react-router-dom';
import AuthProvider from '@/providers/AuthProvider';
import GoogleOAuthProviderWrapper from '@/providers/GoogleOAuthProvider';
import { PlanLimitsProvider } from '@/contexts/PlanLimitsContext';

export default function RouterWrapper() {
  return (
    <AuthProvider>
      <GoogleOAuthProviderWrapper>
        <PlanLimitsProvider>
          <Outlet />
        </PlanLimitsProvider>
      </GoogleOAuthProviderWrapper>
    </AuthProvider>
  );
}
